export const EMPTY_BLOCK_CONTAINER_TEST_ID = 'empty-block-container';
